<template>
	<div class="main">
		<el-config-provider :locale="locale">
			<router-view></router-view>
		</el-config-provider>
	</div>
</template>

<script lang="ts" setup>
import { onMounted, getCurrentInstance, ref } from 'vue';

// 中文、繁体、英文
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import zhTw from 'element-plus/dist/locale/zh-tw.mjs'
import en from 'element-plus/dist/locale/en.mjs'

const language = ref(localStorage.getItem("language") || 'cn')
const locale = ref('')
if (language.value == 'tc') {
	locale.value = zhTw
} else if (language.value == 'en') {
	locale.value = en
} else {
	locale.value = zhCn
}

const { proxy } = getCurrentInstance() as any;

onMounted(() => {
	let href = window.location.href;
	if (href.indexOf("localhost") > -1) {
		proxy.$store.commit("SetMode", 1);
	} else {
		proxy.$store.commit("SetMode", 2);
	}
	// var docEl = document.documentElement,
	// 	resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
	// 	recalc = function () {
	// 		var clientWidth = docEl.clientWidth;
	// 		if (!clientWidth) return;
	// 		docEl.style.fontSize = 100 * (clientWidth / 1920) + 'px';
	// 	};
	// if (!document.addEventListener) return;
	// window.addEventListener(resizeEvt, recalc, false);
	// document.addEventListener('DOMContentLoaded', recalc, false);
})
</script>

<style>
* {
	padding: 0;
	margin: 0;
}

.main {
	/* font-size: 1.296296vw; */
	height: 100vh;
	color: #393E4D;
}
</style>